import CallApi from '../../apiClient'
import { routes } from './routes'

export const userInvites = async (email) => {
  return CallApi(routes.users_invites, email)
}

export const resendUsersInvite = async (guid, params) => {
  return CallApi(
    {
      ...routes.resend_invitation,
      url: routes.resend_invitation.url.replace(':guid', guid)
    },
    params
  )
}
